export const SITE_NAME = "吃瓜日报";
export const SITE_URL = "https://bc-digital.cn";
export const SITE_DESC =
  "实时吃瓜平台：聚合全网热门大瓜、实时吃瓜合集与盘点整理。综艺前线、演出舞台、短剧风口、饭圈文化一站式吃瓜，蹲后续不迷路。";
export const SITE_KEYWORDS =
  "实时吃瓜,实时吃瓜合集,实时吃瓜盘点,实时吃瓜大瓜,吃瓜日报";
export const OG_IMAGE =
  "https://readdy.ai/api/search-image?query=watermelon%20slice%20on%20warm%20cream%20paper%20with%20editorial%20news%20clippings%20and%20red%20tape%2C%20warm%20coral%20and%20green%20tones%2C%20magazine%20style%20collage%2C%20high%20detail&width=1200&height=630&seq=og-default&orientation=landscape";